let actions = require("./actions.js");
let utils = require("./utils.js");
let newUtils = require("./newUtils.js");
var bcore
function decide() {

}

decide.getDecide = function (obj, callback) {

    //console.log(JSON.stringify(obj));
    if (obj.state > 0) {
        if (obj.PlayerData.hand_helper.indexOf("a Royal Flush") > -1 || obj.PlayerData.hand_helper.indexOf("a Straight Flush") > -1) {
            var _val = decide.actionSend(callback, obj);

            actions.handTen(_val[0], _val[1], _val[2], _val[3], _val[4]);

            return false;
        }
    }

    switch (obj.state) {
        case 0:
            // console.log(JSON.stringify(obj));
            decide.preFlop(obj, callback);
            return false;
            break;
        case 1:
            // console.log(JSON.stringify(obj));
            decide.flop(obj, callback);
            return false;
            break;
        case 2:
            decide.flop(obj, callback);
            return false;
            break;
        case 3:
            decide.flop(obj, callback);
            return false;
            break;
    }
};
decide.GetOtherOdds = function (obj) {
    var oDDs = [];
   obj.players.filter(p => {
        return p.username != obj.PlayerData.username;
    }).map(p => {
        var PlayeroDDs = p.cardsOdds;
        for (var prop in PlayeroDDs) {
                    if (PlayeroDDs.hasOwnProperty(prop)) {
                        if (PlayeroDDs[prop].nuts) {
                            var _odds = PlayeroDDs[prop];
                            _odds.player = PlayeroDDs.Player;
                            _odds.handname = prop;
                            oDDs.push(_odds);
                        } else {
                            if (PlayeroDDs["flush"].length > 0 && prop == "flush") {
                                for (var i = 0; i < PlayeroDDs["flush"].length; i++) {
                                    var _odds = PlayeroDDs["flush"][i];
                                    _odds.player = PlayeroDDs.Player;
                                    _odds.handname = "flush";

                                    oDDs.push(_odds);
                                }
                            }
                        }
                    }
                }
    })
   
  
  
    return oDDs.length;
};

function getCenStrOdds(cards, flop, nuts, num,obj) {
    if (num >= 14) {
        return [];
    }
    var mynum = nuts > 0 ? nuts : 0;
    var finalCardUser = [];
    var finalCardFlop = [];
    var strOds = [];

    var cardsHigh = utils.SortStraight(cards);
    var cardsHighFlop = utils.SortStraight(flop);

    var isNuts = false;

    var carStr = 0;

    for (var j = 0; j < cardsHigh.length - 1; j++) {
        if (cardsHigh[j] - 4 <= cardsHigh[j + 1]) {
            if (!finalCardUser.includes(cardsHigh[j])) {
                finalCardUser.push(cardsHigh[j]);
            }
            if (!finalCardUser.includes(cardsHigh[j + 1])) {
                finalCardUser.push(cardsHigh[j + 1]);
            }
        }
    }
    for (var j = 0; j < cardsHighFlop.length - 1; j++) {
        if (cardsHighFlop[j] - 4 <= cardsHighFlop[j + 1]) {
            if (!finalCardFlop.includes(cardsHighFlop[j])) {
                finalCardFlop.push(cardsHighFlop[j]);
            }
            if (!finalCardFlop.includes(cardsHighFlop[j + 1])) {
                finalCardFlop.push(cardsHighFlop[j + 1]);
            }
        }
    }
    finalCardFlop.sort(utils.compareNumbers);
    finalCardUser.sort(utils.compareNumbers);
    var start = finalCardFlop[1] + 4;
    if (start > 14) {
        start = 14;
    }

    var end = finalCardFlop[finalCardFlop.length - 2] - 5;
    if (end < 1) {
        end = 1;
    }
    // console.log(finalCardFlop, finalCardUser,start,end)

    var defflop = finalCardFlop;
    var newnuts = mynum;
    var resflop = [];
    for (var i = start; i >= end; i--) {
        //console.log(finalCardFlop,i,strOds.includes(i))
        var res = [];

        if (!finalCardFlop.includes(i) && !strOds.includes(i)) {
            defflop = finalCardFlop;

            //defflop = defflop.concat(cards);
            defflop.push(i);

            res = getCenStrOddsIs(cards, defflop,obj);

            if (res.nuts && num - 4 < i && res.flop[4] <= i && res.nuts > newnuts && res.high > num) {
                //console.log(res)
                if (num) {
                    newnuts = res.nuts;



                }
                const high = Math.max(...res.flop);
                resflop.push(high);
                strOds.push(i);
            }
            defflop.pop();
        }
        // defflop=  defflop.slice(0,(flop.length+1) * -1)
    }
    if (strOds.length == 0 || flop.length == 5) {
        return [];
    }
    //console.log(resflop);

    var straight = {
        flop: finalCardFlop,

        nuts: strOds.length > 3 ? 14 : num > 0 ? newnuts : (strOds.length * 12) / (flop.length + 1),
        cards: strOds,
        high: resflop.reduce(function (a, b) {
            return a + b
        }) / resflop.length,
        notRaise: true,
        num: num,
    };
    straight = decide.CleanOddsNuts(straight, "straight", flop,obj);
    return straight;
}
function getCenStrOddsIs(myCards, flop,obj) {
    var cards = myCards;
    var cardArr = {};
    if (cards.toString().indexOf("A") > -1 && !cards.includes("1")) {
        cards.push("1");
    }
    //console.log(cards)
    for (var j = 0; j < cards.length - 1; j++) {
        for (var i = j + 1; i < cards.length; i++) {
            var count = cards[j][0] + cards[i][0];
            var canAdd = utils.getHigh(cards[j]) - 4 <= utils.getHigh(cards[i]);
            if (utils.getHigh(cards[j]) < utils.getHigh(cards[i])) {
                canAdd = utils.getHigh(cards[i]) - 4 <= utils.getHigh(cards[j]);
                count = cards[i][0] + cards[j][0];
            }
            if (utils.getHigh(cards[j]) == utils.getHigh(cards[i])) {
                canAdd = false;
            }

            if (canAdd) {
                cardArr["" + count + ""] = [cards[j], cards[i]];
            }
        }
    }
    //console.log(cardArr)

    var isstr8 = false;
    var strcards = [];
    var strtotalcards = [];

    var cardsHighFlop = utils.SortStraight(flop);
    if (cardsHighFlop.includes(14)) {
        cardsHighFlop.push(1);
    }

    for (var prop in cardArr) {
        if (strcards.length >= 0) {
            var defflop = cardsHighFlop;
            var finalCardFlop = [];
            var myhand = utils.SortStraight(cardArr[prop]);
            defflop = defflop.concat(myhand);
            defflop = utils.SortStraight(defflop);
            //console.log(defflop)
            if (defflop.includes(14)) {
                defflop.push(1);
            }
            for (var j = 0; j < defflop.length - 1; j++) {
                if (defflop[j] - 4 <= defflop[j + 1] && defflop[j] - 4 <= myhand[1]) {
                    if (!finalCardFlop.includes(defflop[j]) && finalCardFlop.length <= 5) {
                        finalCardFlop.push(defflop[j]);
                    }
                    if (!finalCardFlop.includes(defflop[j + 1]) && finalCardFlop.length <= 5) {
                        finalCardFlop.push(defflop[j + 1]);
                    }
                }
            }
            //console.log(finalCardFlop, utils.SortStraight(cardArr[prop]))
            //finalCardFlop = SortStraight(finalCardFlop);

            var defstr = utils.isStraight(finalCardFlop);
            var defcard = utils.SortStraight(cardArr[prop]);

            if (defstr && defstr.includes(defcard[0]) && defstr.includes(defcard[1])) {
                strcards = defcard;
                strtotalcards = defstr;
                isstr8 = true;
            }
        }
    }
    if (isstr8) {
        // console.log("getCenStrOddsIs", strcards, strtotalcards, cardsHighFlop);
        // console.log((14 - (strtotalcards[0] - strcards[0]) + (14 - (strtotalcards[1] - strcards[1]))) / 2);

        var muhighCard = strcards[0] - strcards[1] >= 3 ? (14 - (strtotalcards[0] - strcards[0]) + (14 - (strtotalcards[1] - strcards[1]))) / 2 : 14 - (strtotalcards[0] - strcards[0] - (strtotalcards[0] - strcards[1]));
        if ((cardsHighFlop.includes(strcards[0]) || cardsHighFlop.includes(strcards[1])) && muhighCard == 14) {
            muhighCard = muhighCard - 1;
        }
        const high = Math.max(...strtotalcards);
        var fnuts = strtotalcards[0] == 14 ? strtotalcards[0] : (14 - (strtotalcards[0] - strcards[0]) + (14 - (strtotalcards[1] - strcards[1]))) / 2;

        var straight = {
            flop: strtotalcards,
            cards: strcards,
            high: high,
            nuts: fnuts,
            notRaise: false,
        };
        straight = decide.CleanOddsNuts(straight, "straight", flop,obj);
        return straight;
    }

    return [];
}
function haveFlushOdds(Player, flop, obj) {

    var cartFlush = [];
    Object.keys(Player.flushOdds).map(function (key) {
        var Flushs = Player.flushOdds[key]
        var Out = obj?.flushout[key]

         var inHigh = newUtils.CleanOddsFlsuh(Player, obj.players, key, Out)
        //var inHigh = true
        if (inHigh && Flushs.odds > 0) {

            //console.log(Out);

            cartFlush.push({
                cartName: key,
                Card: Flushs.Card,

                out: Out.out,
                odds: Flushs.odds,
                notRaise: ((Flushs.odds >= 30 && Player?.Net <= obj?.amounts?.BB * -20) || (Flushs.odds >= 100)) ? false : true,

                high: Flushs.high,
                nuts: Out.nuts,
            });
        }


    })


    if (cartFlush.length == 0) {
        return [];
    }

    cartFlush = decide.CleanOddsNuts(cartFlush, "flush", flop,obj);
    //console.log(cartFlush);
    return cartFlush;
}
decide.haveFullOdds = function (cards, flop) {
    function generateCombinations(cards, k) {
        const result = [];
        function backtrack(start, currentCombination) {
            if (currentCombination.length === k) {
                result.push([...currentCombination]);
                return;
            }
            for (let i = start; i < cards.length; i++) {
                currentCombination.push(cards[i]);
                backtrack(i + 1, currentCombination);
                currentCombination.pop();
            }
        }
        backtrack(0, []);
        return result;
    }
    const twoHoleCardCombinations = generateCombinations(cards, 2);
    var fullRank = 0
    var currentRank = []

    for (const twoCards of twoHoleCardCombinations) {
        // Combine with all combinations of three community cards
        const threeCommunityCardCombinations = generateCombinations(flop, 3);

        for (const threeCards of threeCommunityCardCombinations) {

            var currentFullRank = haveFullOdds(twoCards, threeCards, flop)// Call your ranking function
            if (currentFullRank?.nuts && currentFullRank?.nuts > fullRank) {
                currentRank = currentFullRank
            }
        }
    }
    return currentRank

};
function haveFullOdds(cards, flop, allflop) {
    //console.log("haveFullOdds", cards, flop);

    var full = [];

    var handPer = utils.groupBy(cards, (v) => v[0]);

    var flopPer = utils.groupBy(flop, (v) => v[0]);
    var allflopPer = utils.groupBy(allflop, (v) => v[0]);
    var havePerUp4Flop = false;
    var havePerUp3Flop = false;
    var havePerUpFlop = false;
    var haveSet = false;
    var perUp2 = 0;
    var perUp3 = 0;
    for (var prop in allflopPer) {
        var propHigh = utils.getHigh(prop);
        if (allflopPer[prop].length == 4) {
            havePerUp4Flop = propHigh

        }
        if (allflopPer[prop].length >= 3 && havePerUp4Flop != propHigh) {
            havePerUp3Flop = propHigh;

        }
        if (allflopPer[prop].length >= 2 && havePerUp3Flop != propHigh && havePerUp4Flop != propHigh) {
            havePerUpFlop = propHigh;

        }

    }


    var total = flop.concat(cards);

    var tot = utils.groupBy(total, (v) => v[0]);
    // console.log(tot)
    for (var prop in tot) {
        var propHigh = utils.getHigh(prop);

        if (tot[prop].length == 2 && cards.toString().indexOf(prop) > -1) {
            if (perUp2 < propHigh) {

                perUp2 = propHigh;
            }
        }
        if (tot[prop].length == 2 && cards.toString().indexOf(prop) == -1) {
            if (perUp2 < propHigh) {

                perUp2 = propHigh;
            }
        }
        if (tot[prop].length > 2 && cards.toString().indexOf(prop) > -1) {
            if (perUp3 < propHigh) {
                // perUp2 =perUp3
                perUp3 = propHigh;
            }
        }




    }


    if (havePerUp4Flop) {
        var highPer = 0;

        for (var prop in handPer) {
            var propHigh = utils.getHigh(prop);
            if (handPer[prop].length >= 2 && highPer < propHigh) {
                highPer = propHigh;
            }

        }
        if (highPer == 0) {
            full = [];
        } else {
            full = {
                highSet: utils.getHigh(perUp3),
                highPer: perUp2,
                nuts: highPer,
                notRaise: highPer > 10 ? false : true,
            };
        }

        return full;
    }

    //console.log(havePerUp3Flop)
    if (havePerUp3Flop) {
        var highPer = 0;

        for (var prop in handPer) {
            var propHigh = utils.getHigh(prop);
            if (handPer[prop].length >= 2 && highPer < propHigh) {
                highPer = propHigh;
            }

        }

        if (highPer == 0) {
            full = [];
        } else {
            full = {
                highSet: havePerUp3Flop,
                highPer: highPer,
                set: havePerUp3Flop,
                per: highPer,
                nuts: highPer,
                notRaise: highPer > 8 ? false : true,
            };
        }
        return full;
    }

    if (!havePerUpFlop) {
        return full;
    }

    if (perUp3 == 0 || perUp2 == 0) {
        return [];
    }
    var cardArr = {};
    var fullhigh = 0;

    var high2 = utils.getNumofCard(perUp2);
    var high3 = utils.getNumofCard(perUp3);
    //console.log(tot, high3, perUp3, perUp2);
    if (handPer[high3] && handPer[high3].length >= 2) {
        //Hidden Full
        if (utils.getHigh(perUp3) > utils.getHigh(perUp2)) {
            //Good Full
            var fnuts = utils.getNust("full", perUp3, allflop);
            full = {
                set: perUp3,
                per: perUp2,
                highSet: utils.getHigh(perUp3),
                highPer: utils.getHigh(perUp2),
                notRaise: fnuts > 5 ? false : true,
                nuts: fnuts,
            };
        } else {
            var fnuts = utils.getNust("full", perUp3, allflop) - (allflop.length - 2);
            full = {
                set: perUp3,
                per: perUp2,
                highSet: utils.getHigh(perUp3),
                highPer: utils.getHigh(perUp2),
                notRaise: fnuts > 5 ? false : true,
                nuts: fnuts,
            };
        }
    } else {
        if (utils.getHigh(perUp3) > utils.getHigh(perUp2)) {
            //Good Full
            var fnuts = utils.getNust("full", perUp2, allflop.toString().replace(perUp3, "").replace(perUp3, ""));
            full = {
                set: perUp3,
                per: perUp2,
                highSet: utils.getHigh(perUp3),
                highPer: utils.getHigh(perUp2),
                notRaise: fnuts > 5 ? false : true,
                nuts: fnuts,
            };
        } else {
            var fnuts = utils.getNust("full", perUp2, allflop.toString().replace(perUp3, "").replace(perUp3, ""));
            full = {
                set: perUp3,
                per: perUp2,
                highSet: utils.getHigh(perUp3),
                highPer: utils.getHigh(perUp2),
                notRaise: fnuts > 5 ? false : true,
                nuts: fnuts,
            };
        }
    }
    //console.log(full);


    return full;
}
function haveSetOdds(cards, flop,obj) {
    var handPer = utils.groupBy(cards, (v) => v[0]);

    var havePerUpHand = false;
    for (var prop in handPer) {
        if (handPer.hasOwnProperty(prop)) {
            if (handPer[prop].length >= 2) {
                havePerUpHand = true;
            }
        }
    }

    if (!havePerUpHand) {
        return [];
    }
    var flopPer = utils.groupBy(flop, (v) => v[0]);
    var havePerUpFlop = false;

    for (var prop in flopPer) {
        if (flopPer.hasOwnProperty(prop)) {
            if (flopPer[prop].length >= 2) {
                havePerUpFlop = true;
            }
        }
    }

    if (havePerUpFlop) {
        return [];
    }
    var set = [];

    var high = 0;
    var total = cards.concat(flop);
    var tot = utils.groupBy(total, (v) => v[0]);

    for (var prop in tot) {
        if (tot.hasOwnProperty(prop)) {
            var h = utils.getHigh(prop);
            if (tot[prop].length >= 3 && flop.toString().indexOf(prop) > -1 && high < h) {
                var fnuts = utils.getNust("set", tot[prop], flop);

                high = h;
                set = {
                    set: prop,
                    high: high,
                    nuts: fnuts,
                    notRaise: false,
                };
            }
        }
    }
    set = decide.CleanOddsNuts(set, "set", flop,obj);
    return set;
}
function haveTreeOdds(cards, flop,obj) {
    var handPer = utils.groupBy(cards, (v) => v[0]);

    var flopPer = utils.groupBy(flop, (v) => v[0]);
    var havePerUpFlop = false;

    for (var prop in flopPer) {
        if (flopPer.hasOwnProperty(prop)) {
            if (flopPer[prop].length >= 2) {
                havePerUpFlop = true;
            }
        }
    }

    if (!havePerUpFlop) {
        return [];
    }
    var set = [];

    var high = 0;
    var total = cards.concat(flop);
    var tot = utils.groupBy(total, (v) => v[0]);

    for (var prop in tot) {
        if (tot.hasOwnProperty(prop)) {
            var h = utils.getHigh(prop);
            if (tot[prop].length >= 3 && flop.toString().indexOf(prop) > -1 && cards.toString().indexOf(prop) > -1 && high < h) {
                var fnuts = utils.getNust("three", cards.toString().replace(prop, "").replace(prop, "").replace(prop, ""), flop);
                if (fnuts < 12) {
                    fnuts = 12;
                }
                high = h;
                set = {
                    set: prop,
                    high: h,
                    nuts: fnuts,
                    notRaise: false,
                };
                set = decide.CleanOddsNuts(set, "set", flop,obj);
            }
        }
    }

    return set;
}

function getTwoPerOdds(cards, flop,obj) {
    var per = [];

    var handPer = utils.getDouble(cards);
    var flopPer = utils.getDouble(flop);
    var cardsflop = [];
    var cardsflopDeck = [];
    var arrayLength = flop.length;

    for (var i = 0; i < arrayLength; i++) {
        if (cards.toString().indexOf(flop[i][0]) > -1) {
            cardsflop.push(utils.getHigh(flop[i]));
        }
        cardsflopDeck.push(utils.getHigh(flop[i]));
    }
    if (handPer && cardsflop.length == 0) {
        cardsflop.push(handPer);
        //cardsflop.push(handPer);
    }
    if (flopPer) {
        if (cardsflop.length == 1) {
            cardsflop.push(flopPer);
        }
        cardsflopDeck.push(flopPer);
        cardsflopDeck.push(flopPer);
    }
    cardsflop.sort(utils.compareNumbers);
    cardsflopDeck.sort(utils.compareNumbers);

    //console.log(cardsflop,cardsflopDeck)
    if (cardsflop.length >= 2) {
        var fnuts = (14 - cardsflopDeck[0] + cardsflop[0] + 14 - cardsflopDeck[1] + cardsflop[1]) / 2;

        per = {
           
            highOne: cardsflop[0],
            hightTwo: cardsflop[1],

            notRaise:  flop.length == 3 ? false : true,
            nuts: fnuts,
        };
        per = decide.CleanOddsNuts(per, "two", flop,obj);
    }

    return per;
}
function getPerOdds(cards, flop,obj) {
    var per = [];

    var handPer = utils.groupBy(cards, (v) => v[0]);
    var cardsflop = [];
    var cardsflopDeck = [];

    var arrayLength = flop.length;
    var flopPer = utils.groupBy(flop, (v) => v[0]);
    var havePerUpFlop = false;

    for (var prop in flopPer) {
        if (flopPer.hasOwnProperty(prop)) {
            if (flopPer[prop].length >= 2) {
                havePerUpFlop = true;
            }
        }
    }

    if (havePerUpFlop) {
        return [];
    }
    for (var i = 0; i < arrayLength; i++) {
        if (cards.toString().indexOf(flop[i][0]) > -1) {
            cardsflop.push(utils.getHigh(flop[i]));
        }
        cardsflopDeck.push(utils.getHigh(flop[i]));
    }
    if (cardsflop.length < 1 && utils.getDouble(cards)) {
        //cardsflop = [];
        for (var prop in handPer) {
            if (handPer.hasOwnProperty(prop)) {
                if (handPer[prop].length >= 2) {
                    cardsflop.push(utils.getHigh(handPer[prop]));
                }
            }
        }
        //cardsflop.push(utils.getHigh(utils.getDouble(flop)));
    }
    //console.log(cardsflop,cardsflopDeck)
    cardsflopDeck.sort(utils.compareNumbers);
    cardsflop.sort(utils.compareNumbers);

    if (cardsflop.length >= 1) {
        var handPer = utils.getHigh(cards.toString().replace(cardsflop[0], ""));
        var handPer2 = utils.getHigh(cards[1]);
        var flophigh = utils.getHigh(flop);
        var perCount = (handPer + handPer2) / 2;
        if (flophigh <= handPer && flophigh <= handPer2) {
            perCount = perCount + 1;
        }

        // var fnuts = (14 - cardsflop[0] + handPer) / 2;
        var fnuts = (14 - cardsflopDeck[0] + perCount) / 2;
        fnuts = fnuts + handPer;
        if (fnuts > 14) {
            // fnuts = 14;
        }
        per = {
            highOne: cardsflop[0],

            notRaise: true,
            nuts: fnuts,
            perCount: perCount,
        };
        per = decide.CleanOddsNuts(per, "two", flop,obj);
    }
 
    return per;
}
function getHighOdds(cards, flop, obj) {
    var per = [];
    var noOut = 0;
    var handPer = utils.getHigh(cards[0]);
    var handPer2 = utils.getHigh(cards[1]);
    var flophigh = utils.getHigh(flop);
    if (flophigh < handPer && flophigh < handPer2) {
        var perCount = (handPer + handPer2) / 2;
       
            per = {
                highOne: handPer,
                hightTwo: handPer2,
                notRaise: true,
                nuts: perCount,
            };
            per = decide.CleanOddsNuts(per, "high", flop,obj);
        }
   

    return per;
}

function haveFourOdds(cards, flop) {
    var four = [];

    var handPer = utils.groupBy(cards, (v) => v[0]);

    var flopPer = utils.groupBy(flop, (v) => v[0]);
    var havePerUp4Flop = false;
    var havePerUp3Flop = false;
    var havePerUpFlop = false;
    var haveSet = false;
    for (var prop in flopPer) {
        if (flopPer.hasOwnProperty(prop)) {
            if (flopPer[prop].length == 4) {
                havePerUp4Flop = true;
            }
            if (flopPer[prop].length == 3) {
                havePerUp3Flop = prop;
            }
            if (flopPer[prop].length >= 2) {
                havePerUpFlop = prop;
            }
        }
    }
    if (havePerUp4Flop) {
        return four;
    }

    if (havePerUp3Flop) {
        if (cards.toString().indexOf(havePerUp3Flop) > -1) {
            four = {
                nuts: 14,
                high: utils.getHigh(havePerUp3Flop),
                notRaise: flop.length == 5 ? false : true,
            };
            return four;
        }
    }

    if (!havePerUpFlop) {
        return four;
    }
    var total = flop.concat(cards);

    var tot = utils.groupBy(total, (v) => v[0]);

    for (var prop in tot) {
        if (tot.hasOwnProperty(prop)) {
            if (tot[prop].length >= 4) {
                four = {
                    nuts: utils.getHigh(prop),
                    high: utils.getHigh(havePerUpFlop),
                    notRaise: false,
                };
            }
        }
    }

    return four;
}
decide.CleanOddsNuts = function (data, name, flop,obj) {
    
    var _data = data;
    var fnuts = _data.nuts;
    var canRaise = _data.notRaise ? _data.notRaise : false;
    var rank = utils.getHandRank(name);
    //console.log("CleanOddsNuts", name, fnuts, rank);


    if (flop.length >= 3) {
        if (name == "two" || name == "straight" || name == "high") {
            if (utils.checkHaveFlushOdds(flop) && !obj?.isLast) {
                canRaise = true;
            }
        }
        if (name == "two" || name == "straight" || name == "high") {
            if (utils.getDouble(flop) && !obj?.isLast) {
                canRaise = true;
            }
        }
        if (name == "two" || name == "high") {
            if (utils.checkHaveStrOdds(flop) && !obj?.isLast) {
                canRaise = true;
            }
        }
    }

    if (name == "flush") {
        var flushdata = data;
        for (var j = 0; j < flushdata.length; j++) {
            _data = flushdata[j];
            fnuts = obj.flushout[_data.cartName].nuts <= _data.high ? 14 : _data.high;
            canRaise = _data.notRaise ? _data.notRaise : false;

            if (utils.getDouble(flop) && !obj.isLast) {
                canRaise = true;
     
            }




            _data.nuts = fnuts;
            _data.notRaise = canRaise;
            flushdata[j] = _data;
        }
        return flushdata;
    }

    _data.nuts = fnuts;
    _data.notRaise = canRaise;

    return _data;
};
decide.CreateOdds = function (PlayerData, flop, player, obj) {


    var cards = PlayerData.hole_cards


    var Odds = {};
    Odds.four = [];
    Odds.full = [];
    Odds.flush = [];
    Odds.set = [];
    Odds.straight = [];
    Odds.isstraight = [];
    Odds.three = [];
    Odds.two = [];
    Odds.per = [];
    Odds.high = [];

    Odds.Player = player;
    Odds.four = haveFourOdds(cards, flop);

    if (!Odds.four.nuts) {
        Odds.full = decide.haveFullOdds(cards, flop);

        if (!Odds.full.nuts) {
            Odds.flush = haveFlushOdds(PlayerData, flop, obj);

            Odds.set = haveSetOdds(cards, flop, obj);
            Odds.three = haveTreeOdds(cards, flop, obj);
            if (!Odds.set.nuts && !Odds.three.nuts) {
                Odds.two = getTwoPerOdds(cards, flop, obj);
                if (!Odds.two.nuts) {
                    Odds.per = getPerOdds(cards, flop, obj);
                    if (!Odds.per.nuts) {
                        Odds.high = getHighOdds(cards, flop, obj);
                    }
                }
            }
            try {
                if (Odds.flush.length == 0 || Odds.flush[0].odds < 100 || flop.length < 5) {
                    if (Odds.flush[0].odds < 100) {
                        var isstr = getCenStrOddsIs(cards, flop, obj);
                        Odds.isstraight = isstr;

                        if (!Odds.isstraight.nuts < 14 || flop.length < 5) {
                            Odds.straight = getCenStrOdds(cards, flop, isstr.cards ? isstr.flop[0] : 0, isstr.cards ? isstr.flop[0] : 0, obj);
                            // Odds.straight =[]
                        }
                    }
                }
                if (Odds.flush.length > 0 && Odds.flush[0].odds >= 100) {
                    if (flop.length == 5) {
                        Odds.set = [];
                        Odds.three = [];
                        Odds.two = [];

                        // Odds.straight =[]
                    }
                    Odds.straight = [];
                    Odds.isstraight = [];
                    Odds.per = [];
                    Odds.high = [];
                }
            } catch (err) {
                var isstr = getCenStrOddsIs(cards, flop, obj);

                Odds.isstraight = isstr;

                if (Odds.isstraight.nuts < 14 || flop.length < 5) {
                    Odds.straight = getCenStrOdds(cards, flop, isstr.cards ? isstr.flop[0] : 0, isstr.cards ? isstr.flop[0] : 0, obj);
                    // Odds.straight =[]
                }
            }
            if (Odds.isstraight.nuts < 14) {
                if (flop.length == 5) {
                    Odds.set = [];
                    Odds.three = [];
                    Odds.two = [];
                    // Odds.straight =[]
                }
                Odds.per = [];
                Odds.high = [];
            }
        }
    }

    return Odds;
};
decide.GetOdds = function (obj) {
    var fourHigh = 0;
    var flushHigh = 0;
    var setHigh = 0;
    var str8High = 0;
    var fullHigh = 0;
    var twoHigh = 0;
    var perHigh = 0;
    var highHigh = 0;
    var AllBots = utils.checkAllBots(obj);

    var PlayeroDDs = obj.PlayerData.cardsOdds;
    // console.log("PlayeroDDs", PlayeroDDs);

    var havePlayer = utils.GetCleanOdds(PlayeroDDs);

    if (havePlayer) {
        obj.players.filter(p => {
            return p.username != obj.PlayerData.username;
        }).map(p => {
            var uOdds = p.cardsOdds;
            //console.log(uOdds);
            var havePlayerUser = utils.GetCleanOdds(uOdds);
            if (havePlayerUser) {
    

                if (p.hand_helper.indexOf("a Royal Flush") > -1 || p.hand_helper.indexOf("a Straight Flush") > -1) {
                    PlayeroDDs.full = [];
                    PlayeroDDs.flush = [];
                    PlayeroDDs.set = [];
                    PlayeroDDs.straight = [];
                    PlayeroDDs.isstraight = [];
                    PlayeroDDs.three = [];
                    PlayeroDDs.two = [];
                    PlayeroDDs.per = [];
                    PlayeroDDs.four = [];
                    PlayeroDDs.high = [];
                }
                if (!AllBots) {
                    if (uOdds.four.nuts) {
                        if (fourHigh < uOdds.four.high) {
                            fourHigh = uOdds.four.high;
                        }
                        if (PlayeroDDs.four.high) {
                            if (fourHigh > PlayeroDDs.four.high) {
                                PlayeroDDs.four = [];
                            }
                        }
                        PlayeroDDs.full = [];
                        PlayeroDDs.flush = [];
                        PlayeroDDs.isstraight = [];
                        PlayeroDDs.straight = [];
                        PlayeroDDs.set = [];
                        PlayeroDDs.two = [];
                        PlayeroDDs.per = [];
                        PlayeroDDs.three = [];
                        PlayeroDDs.high = [];
                        havePlayer = utils.PrintCleanOdds(uOdds, "four", obj, prop, PlayeroDDs);
                    }

                    if (uOdds.full.nuts) {
                        if (fullHigh < uOdds.full.nuts + uOdds.full.highSet) {
                            fullHigh = uOdds.full.nuts + uOdds.full.highSet;
                        }
                        if (PlayeroDDs.full.nuts) {
                            if (fullHigh > PlayeroDDs.full.nuts + PlayeroDDs.full.highSet) {
                                PlayeroDDs.full = [];
                            }
                        }
                        PlayeroDDs.flush = [];
                        PlayeroDDs.isstraight = [];
                        PlayeroDDs.straight = [];
                        PlayeroDDs.two = [];
                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];
                        if (obj.flopCards.length == 5) {
                            PlayeroDDs.set = [];
                            PlayeroDDs.three = [];
                        } else {
                            PlayeroDDs.set.notRaise = true;
                            PlayeroDDs.three.notRaise = true;
                            if (PlayeroDDs.set.nuts) {
                                if (uOdds.full.highSet > PlayeroDDs.set.nuts || (uOdds.full.highSet == PlayeroDDs.set.nuts && uOdds.full.highPer > utils.getHigh(obj.PlayerData.hole_cards))) {
                                    PlayeroDDs.set = [];
                                }
                            }
                            if (PlayeroDDs.three.nuts) {
                                if (uOdds.full.highSet > PlayeroDDs.three.high || (uOdds.full.highSet == PlayeroDDs.three.high && uOdds.full.highPer > utils.getHigh(obj.PlayerData.hole_cards))) {
                                    PlayeroDDs.three = [];
                                }
                            }
                        }
                        havePlayer = utils.PrintCleanOdds(uOdds, "full", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.flush.length > 0) {
                        for (var j = 0; j < uOdds.flush.length; j++) {
                            if (flushHigh < uOdds.flush[j].nuts) {
                                flushHigh = uOdds.flush[j].nuts;
                            }

                            if (uOdds.flush[j].odds >= 100) {
                                PlayeroDDs.isstraight = [];
                                PlayeroDDs.straight = [];
                                PlayeroDDs.per = [];
                                PlayeroDDs.high = [];
                                if (obj.flopCards.length == 5) {
                                    PlayeroDDs.set = [];
                                    PlayeroDDs.three = [];
                                    PlayeroDDs.two = [];
                                } else {
                                    PlayeroDDs.set.notRaise = true;
                                    PlayeroDDs.three.notRaise = true;
                                    PlayeroDDs.two.notRaise = true;
                                }
                            }
                        }
                        havePlayer = utils.PrintCleanOdds(uOdds, "flush", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.isstraight.high) {
                        if (str8High < uOdds.isstraight.high + uOdds.isstraight.nuts) {
                            str8High = uOdds.isstraight.high + uOdds.isstraight.nuts;
                        }
                        if (PlayeroDDs.isstraight.high) {
                            if (str8High > PlayeroDDs.isstraight.high + PlayeroDDs.isstraight.nuts) {
                                PlayeroDDs.isstraight = [];
                            }
                        }
                        if (PlayeroDDs.straight.high) {
                            if (str8High >= PlayeroDDs.straight.high + PlayeroDDs.straight.nuts) {
                                PlayeroDDs.straight = [];
                            }
                        }
                        if (obj.flopCards.length == 5) {
                            PlayeroDDs.set = [];
                            PlayeroDDs.three = [];
                            PlayeroDDs.two = [];

                            PlayeroDDs.straight = [];
                        } else {
                            PlayeroDDs.set.notRaise = true;
                            PlayeroDDs.three.notRaise = true;
                            PlayeroDDs.two.notRaise = true;
                        }
                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];
                        havePlayer = utils.PrintCleanOdds(uOdds, "isstraight", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.straight.high) {
                        if (str8High < uOdds.straight.high + uOdds.straight.nuts) {
                            str8High = uOdds.straight.high + uOdds.straight.nuts;
                        }
                        if (PlayeroDDs.straight.high) {
                            if (str8High > PlayeroDDs.straight.high + PlayeroDDs.straight.nuts) {
                                PlayeroDDs.straight = [];
                            }
                        }

                        havePlayer = utils.PrintCleanOdds(uOdds, "straight", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.set.nuts) {
                        if (setHigh < uOdds.set.nuts) {
                            setHigh = uOdds.set.nuts;
                        }
                        if (PlayeroDDs.set.nuts) {
                            if (setHigh > PlayeroDDs.set.nuts) {
                                PlayeroDDs.set = [];
                            }
                        }
                        PlayeroDDs.two = [];
                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];
                        havePlayer = utils.PrintCleanOdds(uOdds, "set", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.three.nuts) {
                        if (setHigh < uOdds.three.nuts) {
                            setHigh = uOdds.three.nuts;
                        }
                        if (PlayeroDDs.three.nuts) {
                            if (setHigh > PlayeroDDs.three.nuts) {
                                PlayeroDDs.three = [];
                            }
                        }
                        PlayeroDDs.two = [];
                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];

                        havePlayer = utils.PrintCleanOdds(uOdds, "three", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.two.nuts) {
                        if (twoHigh < uOdds.two.nuts + uOdds.two.highOne) {
                            twoHigh = uOdds.two.nuts + uOdds.two.highOne;
                        }
                        if (PlayeroDDs.two.nuts) {
                            if (twoHigh > PlayeroDDs.two.nuts + PlayeroDDs.two.highOne) {
                                PlayeroDDs.two = [];
                            }
                            if (twoHigh == PlayeroDDs.two.nuts + PlayeroDDs.two.highOne) {
                                PlayeroDDs.two.notRaise = true;
                            }
                        }
                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];
                        havePlayer = utils.PrintCleanOdds(uOdds, "two", obj, prop, PlayeroDDs);
                        //utils.PrintCleanOdds(uOdds,"two",obj,prop)
                    }
                    if (uOdds.per.nuts) {
                        if (perHigh < uOdds.per.nuts + uOdds.per.highOne) {
                            perHigh = uOdds.per.nuts + uOdds.per.highOne;
                        }
                        if (PlayeroDDs.per.nuts) {
                            if (perHigh > PlayeroDDs.per.nuts + PlayeroDDs.per.highOne) {
                                PlayeroDDs.per = [];
                            }
                            if (perHigh == PlayeroDDs.per.nuts + PlayeroDDs.per.highOne) {
                                PlayeroDDs.per.notRaise = true;
                            }
                        }
                        PlayeroDDs.high = [];
                        havePlayer = utils.PrintCleanOdds(uOdds, "per", obj, prop, PlayeroDDs);
                        //utils.PrintCleanOdds(uOdds,"per",obj,prop)
                    }
                    if (uOdds.high.nuts) {
                        if (highHigh < uOdds.high.nuts) {
                            highHigh = uOdds.high.nuts;
                        }
                        if (PlayeroDDs.high.nuts) {
                            if (highHigh > PlayeroDDs.high.nuts) {
                                PlayeroDDs.high = [];
                            }
                            havePlayer = utils.PrintCleanOdds(uOdds, "high", obj, prop, PlayeroDDs);
                        }
                    }
                } else {
                    if (uOdds.four.nuts) {
                        PlayeroDDs.isstraight = [];
                        PlayeroDDs.straight = [];
                        PlayeroDDs.set = [];
                        PlayeroDDs.two = [];
                        PlayeroDDs.per = [];
                        PlayeroDDs.three = [];
                        PlayeroDDs.high = [];
                        PlayeroDDs.full.notRaise = true;
                        havePlayer = utils.PrintCleanOdds(uOdds, "four", obj, prop, PlayeroDDs);
                    }

                    if (uOdds.full.nuts) {
                        if (fullHigh < uOdds.full.nuts + uOdds.full.highSet) {
                            fullHigh = uOdds.full.nuts + uOdds.full.highSet;
                        }
                        if (PlayeroDDs.full.nuts) {
                            if (fullHigh > PlayeroDDs.full.nuts + PlayeroDDs.full.highSet) {
                                PlayeroDDs.full.notRaise = true;
                            }
                        }
                        PlayeroDDs.flush.notRaise = true;
                        PlayeroDDs.isstraight.notRaise = true;
                        PlayeroDDs.straight = [];
                        PlayeroDDs.two = [];
                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];
                        if (obj.flopCards.length == 5) {
                            PlayeroDDs.set.notRaise = true;
                            PlayeroDDs.three.notRaise = true;
                        } else {
                            PlayeroDDs.set.notRaise = true;
                            PlayeroDDs.three.notRaise = true;
                        }
                        havePlayer = utils.PrintCleanOdds(uOdds, "full", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.flush.length > 0) {
                        for (var j = 0; j < uOdds.flush.length; j++) {
                            if (flushHigh < uOdds.flush[j].nuts) {
                                flushHigh = uOdds.flush[j].nuts;
                            }
                            if (PlayeroDDs.flush.length > 0) {
                                if (flushHigh > PlayeroDDs.flush[0].nuts && uOdds.flush[j].cartName == PlayeroDDs.flush[0].cartName) {
                                    PlayeroDDs.flush[0].notRaise = true;
                                }
                            }
                            if (uOdds.flush[j].odds >= 100) {
                                PlayeroDDs.isstraight.notRaise = true;
                                PlayeroDDs.straight = [];
                                PlayeroDDs.per = [];
                                PlayeroDDs.high = [];
                                if (obj.flopCards.length == 5) {
                                    PlayeroDDs.set.notRaise = true;
                                    PlayeroDDs.three = [];
                                    PlayeroDDs.two = [];
                                } else {
                                    PlayeroDDs.set.notRaise = true;
                                    PlayeroDDs.three.notRaise = true;
                                    PlayeroDDs.two = [];
                                }
                            }
                        }
                        havePlayer = utils.PrintCleanOdds(uOdds, "flush", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.isstraight.high) {
                        if (str8High < uOdds.isstraight.high + uOdds.isstraight.nuts) {
                            str8High = uOdds.isstraight.high + uOdds.isstraight.nuts;
                        }
                        if (PlayeroDDs.isstraight.high) {
                            if (str8High > PlayeroDDs.isstraight.high + PlayeroDDs.isstraight.nuts) {
                                PlayeroDDs.isstraight.notRaise = true;
                            }
                        }
                        if (PlayeroDDs.straight.high) {
                            if (str8High >= PlayeroDDs.straight.high + PlayeroDDs.straight.nuts) {
                                PlayeroDDs.straight = [];
                            }
                        }
                        if (obj.flopCards.length == 5) {
                            PlayeroDDs.set.notRaise = true;
                            PlayeroDDs.three = [];
                            PlayeroDDs.two = [];
                            PlayeroDDs.straight = [];
                        } else {
                            PlayeroDDs.set.notRaise = true;
                            PlayeroDDs.three = [];
                            PlayeroDDs.two = [];
                        }
                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];
                        havePlayer = utils.PrintCleanOdds(uOdds, "isstraight", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.straight.high) {
                        if (str8High < uOdds.straight.high + uOdds.straight.nuts) {
                            str8High = uOdds.straight.high + uOdds.straight.nuts;
                        }
                        if (PlayeroDDs.straight.high) {
                            if (str8High > PlayeroDDs.straight.high + PlayeroDDs.straight.nuts) {
                                PlayeroDDs.straight = [];
                            }
                        }

                        havePlayer = utils.PrintCleanOdds(uOdds, "straight", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.set.nuts) {
                        if (setHigh < uOdds.set.nuts) {
                            setHigh = uOdds.set.nuts;
                        }
                        if (PlayeroDDs.set.nuts) {
                            if (setHigh > PlayeroDDs.set.nuts) {
                                PlayeroDDs.set.notRaise = true;
                            }
                        }
                        PlayeroDDs.two.notRaise = true;
                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];
                        havePlayer = utils.PrintCleanOdds(uOdds, "set", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.three.nuts) {
                        if (setHigh < uOdds.three.nuts) {
                            setHigh = uOdds.three.nuts;
                        }
                        if (PlayeroDDs.three.nuts) {
                            if (setHigh > PlayeroDDs.three.nuts) {
                                PlayeroDDs.three.notRaise = true;
                            }
                        }
                        PlayeroDDs.two.notRaise = true;
                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];

                        havePlayer = utils.PrintCleanOdds(uOdds, "three", obj, prop, PlayeroDDs);
                    }
                    if (uOdds.two.nuts) {
                        if (twoHigh < uOdds.two.nuts + uOdds.two.highOne) {
                            twoHigh = uOdds.two.nuts + uOdds.two.highOne;
                        }
                        if (PlayeroDDs.two.nuts) {
                            if (twoHigh > PlayeroDDs.two.nuts + PlayeroDDs.two.highOne) {
                                PlayeroDDs.two = [];
                            }
                            if (twoHigh == PlayeroDDs.two.nuts + PlayeroDDs.two.highOne) {
                                PlayeroDDs.two.notRaise = true;
                            }
                        }

                        PlayeroDDs.per = [];
                        PlayeroDDs.high = [];
                        havePlayer = utils.PrintCleanOdds(uOdds, "two", obj, prop, PlayeroDDs);
                        //utils.PrintCleanOdds(uOdds,"two",obj,prop)
                    }
                    if (uOdds.per.nuts) {
                        if (perHigh < uOdds.per.nuts + uOdds.per.highOne) {
                            perHigh = uOdds.per.nuts + uOdds.per.highOne;
                        }
                        if (PlayeroDDs.per.nuts) {
                            if (perHigh > PlayeroDDs.per.nuts + PlayeroDDs.per.highOne) {
                                PlayeroDDs.per = [];
                            }
                            if (perHigh == PlayeroDDs.per.nuts + PlayeroDDs.per.highOne) {
                                PlayeroDDs.per.notRaise = true;
                            }
                        }
                        PlayeroDDs.high = [];
                        havePlayer = utils.PrintCleanOdds(uOdds, "per", obj, prop, PlayeroDDs);
                        //utils.PrintCleanOdds(uOdds,"per",obj,prop)
                    }
                    if (uOdds.high.nuts) {
                        if (highHigh < uOdds.high.nuts) {
                            highHigh = uOdds.high.nuts;
                        }
                        if (PlayeroDDs.high.nuts) {
                            if (highHigh > PlayeroDDs.high.nuts) {
                                PlayeroDDs.high = [];
                            }
                            havePlayer = utils.PrintCleanOdds(uOdds, "high", obj, prop, PlayeroDDs);
                        }
                    }
                }
                havePlayer = utils.GetCleanOdds(PlayeroDDs);
            }
        })

    }

    var odds = 0;
    var oddsName = "";
    var oddsStr = [];
    var oddsCount = 0;
    //console.log("odds", odds,"oddsName",oddsName,PlayeroDDs)
    for (var prop in PlayeroDDs) {
        if (PlayeroDDs.hasOwnProperty(prop)) {
            if (PlayeroDDs[prop].nuts) {
                if (odds < PlayeroDDs[prop].nuts || (odds <= PlayeroDDs[prop].nuts && !PlayeroDDs[prop].notRaise)) {
                    odds = PlayeroDDs[prop].nuts;
                    oddsStr = PlayeroDDs[prop];
                    oddsName = prop;
                }
                if (!PlayeroDDs[prop].notRaise) {
                    oddsCount = oddsCount + 1;
                }
                // odds = odds + PlayeroDDs[prop].nuts
                //oddsCount = oddsCount + 1
            }
        }
    }
    //console.log("odds", odds,"oddsName",oddsName,PlayeroDDs)
    if (PlayeroDDs["flush"].length > 0) {
        for (var i = 0; i < PlayeroDDs["flush"].length; i++) {
            if (PlayeroDDs["flush"][i].nuts) {

                if (odds < PlayeroDDs["flush"][i].nuts || (odds <= PlayeroDDs["flush"][i].nuts && !PlayeroDDs["flush"][i].notRaise)) {
                    odds = PlayeroDDs["flush"][i].nuts;

                    oddsStr = PlayeroDDs["flush"][i];
                    oddsName = "flush";
                    if (!PlayeroDDs["flush"][i].notRaise) {
                        oddsCount = oddsCount + 1;
                    }

                }
            }
        }
    }
    //console.log("odds", odds, "oddsName", oddsName, PlayeroDDs);

    var finalcount = oddsCount > 0 ? oddsCount : 1;
    var finalOds = parseInt((odds * 100) / 14);

    if (finalOds > 100 || oddsName == "four") {
        finalOds = 100;
    }
    if (oddsName == "flush") {
        finalOds = oddsStr.odds;
    }

   
    var isFlush = true;
    if (oddsStr.notRaise) {
        isFlush = false;
    }

    if (oddsName == "") {
        isFlush = false;
    }

    if (oddsCount > 0) { oddsStr.notRaise = false; }

    //console.log("PlayeroDDs", obj.tablename + " " + obj.handnumber + " " + obj.Player + " ---  " + obj.state, oddsStr, finalOds, isFlush, oddsName);
    return [finalOds, isFlush, oddsName, AllBots, oddsStr];
};
decide.actionSend = function (callback, obj, amount) {
    var AllBots = utils.checkAllBots(obj);

    var OtherBlof = obj.state > 0 ? decide.GetOtherOdds(obj) : 0;

    if (amount) {
        return [amount, callback, obj, AllBots, OtherBlof];
    }
    return [callback, obj, AllBots, OtherBlof];
};

decide.call = function (callback, obj) {
    var _val = decide.actionSend(callback, obj);

    actions.call(_val[0], _val[1], _val[2], _val[3], _val[4]);
};
decide.fold = function (callback, obj) {
    var _val = decide.actionSend(callback, obj);

    actions.fold(_val[0], _val[1], _val[2], _val[3], _val[4]);
};
decide.raise = function (amount, callback, obj) {
    var _val = decide.actionSend(callback, obj, amount);

    actions.raise(_val[0], _val[1], _val[2], _val[3], _val[4], _val[5]);
};
decide.check = function (callback, obj) {
    var _val = decide.actionSend(callback, obj);

    actions.check(_val[0], _val[1], _val[2], _val[3], _val[4]);
};

decide.callfunction = function (obj, callback, myprecentage) {
    var precentage = myprecentage[0];
    var canRaise = myprecentage[1];
    
    var rest = obj.Chips;

    var total = obj.total > obj.Pot ? obj.total : obj.Pot;
    var pNum = utils.checkPlayerNumber(obj) + 1;
    var inPot = obj.inPot > 0 ? obj.inPot : 1;
    var callAm = obj.Call;
    var Uipot = utils.checkInpot(obj);
    var _am = utils.getRaiseAnount(obj, precentage);
    if (callAm > 0) {
        total = total + callAm + rest;
    }
    var inPotPercent = 100 - (inPot * 100) / total;
    var inCallPercent = (callAm * 100) / total;
    var inPotCallPercent = parseInt((inCallPercent + inPotPercent) / (pNum));
    //console.log(precentage, inPotCallPercent);
    if (myprecentage[3] != "" && canRaise) {
        if (!Uipot && 100 != precentage) {
            decide.call(callback, obj);
            return false;
        }
        if (myprecentage[3] != "high" && myprecentage[3] != "per" && myprecentage[3] != "flush" && myprecentage[3] != "full") {
            try {
                if (!bcore.Clients[obj.Player].showCard) {
                    bcore.Clients[obj.Player].showCard = true;
                }
            } catch (error) {

            }

        }
        decide.raise(_am, callback, obj);
        return false;
    }
  

    if (myprecentage[3] != "" && !canRaise && precentage >= inPotCallPercent) {
        decide.call(callback, obj);
        return false;
    }

    decide.fold(callback, obj);
    return false;
};
decide.checkfunction = function (obj, callback, myprecentage) {
    var precentage = myprecentage[0];
    var canRaise = myprecentage[1];
   
    var AllBots = myprecentage[4];

    var _am = utils.getRaiseAnount(obj, precentage);


    if (myprecentage[3] != "" && canRaise) {
        decide.raise(_am, callback, obj);
        return false;
    }



    if (myprecentage[3] != "" && 70 <= precentage && !canRaise && !AllBots) {
        if (myprecentage[3] != "high" && myprecentage[3] != "per" && myprecentage[3] != "flush" && myprecentage[3] != "straight") {
            try {
                if (!bcore.Clients[obj.Player].showCard) {
                    bcore.Clients[obj.Player].showCard = true;
                }
            } catch (error) {

            }

            decide.raise(_am, callback, obj);
            return false;
        }
    }
    decide.check(callback, obj);
    return false;
};

decide.preFlop = function (obj, callback) {
    var rest = obj.Chips;
    var stt = utils.checkBankStat(obj);
    var winner = stt > 0 ? true : false;
    var looser = stt < 0 ? true : false;


    
    var canCall = parseInt(obj.canCall);
    var inPot = obj.inPot > 0 ? obj.inPot : 0;

    var total = obj.total > obj.Pot ? obj.total : obj.Pot;
    var callAm = obj.Call;
    if (callAm > 0) {
        if (callAm > rest) {
            callAm = rest;
        }
        total = total + callAm;
    }
    var carereaise = canCall * obj.amounts.BB > total + callAm;
    if (obj.Button2 == "Call") {

        //console.info(canCall * obj.amounts.BB > inPot + callAm);
        if (carereaise && canCall >= 30) {
            decide.raise(obj.MaxRaise, callback, obj);
            return false;
        }



        var canusercall = false;

        if (canCall * obj.amounts.BB >= callAm / 3) {
            canusercall = true;
        }
        if (callAm <= obj.amounts.BB && inPot > 0) {
            canusercall = true;
        }
        if (callAm <= inPot) {
            canusercall = true;
        }
        if (canusercall) {
            decide.call(callback, obj);
            return false;
        }
        decide.fold(callback, obj);
        return false;
    } else if (obj.Button2 == "Check") {
        if (carereaise && canCall >= 10) {
            decide.raise(obj.MaxRaise, callback, obj);
            return false;
        }

        decide.check(callback, obj);
        return false;
    }
};

decide.flop = function (obj, callback) {
    var precentage = decide.GetOdds(obj);
    if (obj.Button2 == "Check") {
        decide.checkfunction(obj, callback, precentage, precentage);
        return false;
    } else if (obj.Button2 == "Call") {
        decide.callfunction(obj, callback, precentage, precentage);

        return false;
    }
};

module.exports = decide;
